//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
import config from "../config.json";
import axios from "axios";

export async function webTopicSubUnsub(payload) {
    try {
        // Not put axios instance apiCall it require no access token in header
        const objresp = await axios.post(`${config.Wave.URL}/notification-engine/${config.TenantId}/v1/webTopicSubUnsub`, payload);
        return objresp;

    } catch (error) {
        console.error('error in getAlaer Api', error);
    }
}
    //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start